/* eslint-disable */
// @ts-nocheck
import * as Types from '../../../types.generated.js';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { customFetcher } from 'libs/data-access/src/lib/custom-fetcher/';
export type GetCurrentTermByRoleAndTypeQueryVariables = Types.Exact<{
  input: Types.FindCurrentByRoleAndTypeInput;
}>;


export type GetCurrentTermByRoleAndTypeQuery = { __typename?: 'Query', getCurrentTermByRoleAndType?: { __typename?: 'Term', versionDate: any, textHtml?: string | null, versionName: string } | null };


export const GetCurrentTermByRoleAndTypeDocument = /*#__PURE__*/ `
    query GetCurrentTermByRoleAndType($input: FindCurrentByRoleAndTypeInput!) {
  getCurrentTermByRoleAndType(input: $input) {
    versionDate
    textHtml
    versionName
  }
}
    `;
export const useGetCurrentTermByRoleAndTypeQuery = <
      TData = GetCurrentTermByRoleAndTypeQuery,
      TError = {extensions: {code: string, serviceName: string, exception: Record<string, unknown>}, message: string}
    >(
      variables: GetCurrentTermByRoleAndTypeQueryVariables,
      options?: UseQueryOptions<GetCurrentTermByRoleAndTypeQuery, TError, TData>
    ) =>
    useQuery<GetCurrentTermByRoleAndTypeQuery, TError, TData>(
      ['GetCurrentTermByRoleAndType', variables],
      customFetcher<GetCurrentTermByRoleAndTypeQuery, GetCurrentTermByRoleAndTypeQueryVariables>(GetCurrentTermByRoleAndTypeDocument, variables),
      options
    );

useGetCurrentTermByRoleAndTypeQuery.getKey = (variables: GetCurrentTermByRoleAndTypeQueryVariables) => ['GetCurrentTermByRoleAndType', variables];
;

export const useInfiniteGetCurrentTermByRoleAndTypeQuery = <
      TData = GetCurrentTermByRoleAndTypeQuery,
      TError = {extensions: {code: string, serviceName: string, exception: Record<string, unknown>}, message: string}
    >(
      variables: GetCurrentTermByRoleAndTypeQueryVariables,
      options?: UseInfiniteQueryOptions<GetCurrentTermByRoleAndTypeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetCurrentTermByRoleAndTypeQuery, TError, TData>(
      ['GetCurrentTermByRoleAndType.infinite', variables],
      (metaData) => customFetcher<GetCurrentTermByRoleAndTypeQuery, GetCurrentTermByRoleAndTypeQueryVariables>(GetCurrentTermByRoleAndTypeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetCurrentTermByRoleAndTypeQuery.getKey = (variables: GetCurrentTermByRoleAndTypeQueryVariables) => ['GetCurrentTermByRoleAndType.infinite', variables];
;

useGetCurrentTermByRoleAndTypeQuery.fetcher = (variables: GetCurrentTermByRoleAndTypeQueryVariables, options?: RequestInit['headers']) => customFetcher<GetCurrentTermByRoleAndTypeQuery, GetCurrentTermByRoleAndTypeQueryVariables>(GetCurrentTermByRoleAndTypeDocument, variables, options);